var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "rounded bg-gray-500 flex flex-col overflow-hidden" },
    [
      _c("button", {
        staticClass: "button bg-zoom-in-white",
        on: {
          click: function ($event) {
            return _vm.zoom(0.1)
          },
        },
      }),
      _c("button", {
        staticClass: "button border-t border-gray-100 bg-zoom-out-white",
        on: {
          click: function ($event) {
            return _vm.zoom(-0.1)
          },
        },
      }),
      _c("button", {
        staticClass: "button border-t border-gray-100 bg-zoom-fit-white",
        on: {
          click: function ($event) {
            return _vm.zoom("fit")
          },
        },
      }),
      _c("button", {
        staticClass: "button border-t border-gray-100 bg-zoom-ori-white",
        on: {
          click: function ($event) {
            return _vm.zoom("ori")
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }